import PropTypes from 'prop-types';
import { memo, useEffect, useState, useRef } from 'react';
import Table from '../../../../components/Table/Table';
import { approvedUsersFetchAction } from '../../../../store/fetchActions/approvedUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import TextInput from '../../../../components/TextInput/TextInput';
import DateInput from '../../../../components/DateInput/DateInput';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import { ImSearch } from 'react-icons/im';
import { userFetchAction } from '../../../../store/fetchActions/usersActions';
import {
  perfisFetchAction,
  profilesUsersFetchAction,
} from '../../../../store/fetchActions/perfisActions';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../../components/Filter/Filter.styles';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import { CircularProgress } from '@material-ui/core';
import Modal from '../../../../components/Modal/Modal';
import { translateMessage } from '../../../../utils/functions/translateMessage';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import { LoadingContainer } from '../../styles/GerenciarClientes.styles';
import { editUserFetchAction } from '../../../../store/fetchActions/editUsersActions';
import InformationCollum from '../Collums/InformationCollum';
import AddressCollum from '../Collums/AddressCollum';
import TaxCollum from '../Collums/TaxCollum';
import Accounts from '../Accounts/Accounts';
import { yupResolver } from '@hookform/resolvers/yup';
import { editUserSchema } from '../../validation/usuariosAprovados.validation';
import ModalPassword from '../../../../components/ModalPassword/ModalPassword';
import LegalRepresentative from '../representativesCard/RepresentativesCard';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { retrievePasswordFetchAction } from '../../../../store/fetchActions/retrievePassword';
import ModalBlockUser from '../Modals/BlockUser';
import {
  ButtonGroup,
  ClickAwayListener,
  Paper,
  MenuList,
  MenuItem,
} from '@material-ui/core';

const { rbmWhite } = theme.colors;
function UsuariosAprovados({ value, index }) {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [isModalBlockUserOpen, setIsModalBlockUserOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const [openDropDownMenu, setOpenDropDownMenu] = useState(false);
  const [nameSelectedItem, setNameSelectedItem] = useState('');
  const [functionSelectedItem, setFunctionSelectedItem] = useState(() => {});

  const {
    approvedUsersData,
    paginationApprovedUsers,
    loadingApprovedUsers,
    errorApprovedUsers,
    errorMessageApprovedUsers,
  } = useSelector((state) => state.approvedUsers);
  const { CPFCNPJ } = useSelector((state) => state?.user?.usersData);

  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });

  useEffect(() => {
    dispatch(profilesUsersFetchAction());
  }, []);

  useCallFilter(filterData, setFilter, approvedUsersFetchAction, value, index);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const { usersData, loadingUser, errorUser, errorMessageUser } = useSelector(
    (state) => state.user
  );

  const {
    handleSubmit: handleUserData,
    control: controlUserForm,
    reset: resetUserForm,
    formState: { errors },
  } = useForm({ resolver: yupResolver(editUserSchema) });

  function edit() {
    setIsEditing(true);
  }

  const { handleSubmit, control, reset } = useForm({});

  const openModalPassword = () => setIsModalPasswordOpen(true);
  const closeModalPassword = () => setIsModalPasswordOpen(false);

  useEffect(() => {
    resetUserForm(usersData);
  }, [usersData, resetUserForm]);

  function cancel() {
    setIsEditing(false);
    resetUserForm();
  }

  const editUser = (data) => {
    const param = {
      CPFCNPJ_CLIENTE: data.CPF_CNPJ,
      EMAIL: data.EMAIL,
      NASCIMENTO: data.NASCIMENTO,
      NOME: data.NOME,
      TELEFONE: data.TELEFONE,
      ID_COBAN: data.PERFIL,
    };

    dispatch(editUserFetchAction(param, 'approvedUsers'));
    dispatch(userFetchAction(param.CPFCNPJ_CLIENTE, 'wontBeLoaded'));
    setIsEditing(false);
  };

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    { id: 'CPFCNPJ', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'perfil ', name: 'PERFIL', align: 'left' },
  ];

  const body = approvedUsersData?.map((user) => {
    return {
      data: [
        { info: user.DATA_INSERT, align: 'center' },
        {
          info:
            user.CPFCNPJ?.length === 11
              ? formatCPF(user.CPFCNPJ)
              : formatCNPJ(user.CPFCNPJ),
          align: 'left',
        },
        { info: user.NOME, align: 'left' },
        { info: user.NOME_COBAN, align: 'left' },
      ],
      onClick: () => inspectUser(user.CPFCNPJ),
    };
  });

  const filterTable = (data) => setFilterData(data);

  function inspectUser(id, contas) {
    dispatch(userFetchAction(id, 'willBeLoaded'));
    dispatch(perfisFetchAction());
    setIsModalInfoOpen(true);
  }

  const closeModalInfo = () => {
    setIsEditing(false);
    setIsModalInfoOpen(false);
  };

  useEffect(() => {
    value != index && (() => setFilterData(''))();
    reset({ SEARCH: '', DATA_INICIAL: '', DATA_FINAL: '', LIMIT: 10, PAGE: 1 });
  }, [value, index]);

  useEffect(() => {
    value === index && (() => dispatch(approvedUsersFetchAction(filter)))();
  }, [dispatch, value, index, filter.PAGE]);

  const anchorRef = useRef(null);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenDropDownMenu(false);
  };

  const handleMenuItemClick = (event, index, nameOption) => {
    setSelectedItem(index);
    setNameSelectedItem(nameOption);
    setOpenDropDownMenu(false);
  };

  const handleButtonsGroup = () => {
    setOpenDropDownMenu((oldState) => !oldState);
  };

  const options = [
    {
      label: 'Bloquear cliente',
      action: 'blockUser',
    },
    {
      label: 'Recuperar senha',
      action: 'recoverPassword',
    },
    {
      label: 'Editar informações',
      action: 'editData',
    },
  ];

  const callFunction = () => {
    const callFunction = {
      editData: () => edit(),
      blockUser: () => setIsModalBlockUserOpen(true),
      unlockUser: () => setIsModalBlockUserOpen(true),
      recoverPassword: () => recoverPassword(),
      showLegalRepresentative: () => showLegalRepresentative(),
    };

    setFunctionSelectedItem(callFunction[nameSelectedItem]);
  };

  const recoverPassword = () => {
    const param = { CPFCNPJ };
    dispatch(retrievePasswordFetchAction(param));
  };

  return (
    <div hidden={value !== index}>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextInput
              label="Nome ou CPF/CNPJ"
              name={'SEARCH'}
              width={'38.042vw'}
              margin={'0 0 0 1.369vw'}
              control={control}
            />
            <DateInput
              label="Data Inicial"
              name={'DATA_INICIAL'}
              control={control}
            />
            <DateInput
              label="Data Final"
              name={'DATA_FINAL'}
              control={control}
            />
            <Button
              backgroundColor={'#303545'}
              width="12.153vw"
              hoverBGColor={'#FF557E'}
              hoverColor={rbmWhite}
              color={'white'}
              type="submit"
              margin={'0 1.389vw 0 0'}
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>
          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions
              control={control}
              options={pagesOptions}
              name={'LIMIT'}
              margin={'0 0 0 1.875vw'}
              initialValue={10}
              initialName={10}
            />
            <h5>Total de resultados: {paginationApprovedUsers?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingApprovedUsers ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          error={errorApprovedUsers}
          hasPagination={true}
          filter={filter}
          pagination={paginationApprovedUsers}
          setFilter={setFilter}
          errorMessage={errorMessageApprovedUsers}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}

      <Modal
        open={isModalInfoOpen}
        close={closeModalInfo}
        title="Detalhes Cliente"
        width={'96.222vw'}
      >
        {loadingUser ? (
          <LoadingContainer marginTop={'1vw'}>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : errorUser ? (
          <h1>{translateMessage(errorMessageUser)}</h1>
        ) : (
          <>
            <Styled.EditButtonContainer>
              <h4>Informações Pessoais</h4>
              <ButtonGroup
                variant="contained"
                ref={anchorRef}
                aria-label="split button"
              >
                <Styled.ButtonOptions
                  aria-controls={
                    openDropDownMenu ? 'split-button-menu' : undefined
                  }
                  aria-expanded={openDropDownMenu ? 'true' : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleButtonsGroup}
                >
                  <span>GERENCIAR</span>
                  {openDropDownMenu ? <ArrowDropUp /> : <ArrowDropDown />}
                </Styled.ButtonOptions>
              </ButtonGroup>
              <Styled.PopperButtonsGroup
                open={openDropDownMenu}
                anchorEl={anchorRef.current}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Styled.GrowButtonsGroup
                    {...TransitionProps}
                    transformOrigin={
                      placement === 'bottom' ? 'center top' : 'center bottom'
                    }
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>
                          {options?.map((option, index) => (
                            <MenuItem
                              key={option?.label}
                              selected={index === selectedItem - 1}
                              onClick={(event) => {
                                !isEditing && openModalPassword();
                                handleMenuItemClick(
                                  event,
                                  index + 1,
                                  option?.action
                                );
                              }}
                            >
                              {option?.label}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Styled.GrowButtonsGroup>
                )}
              </Styled.PopperButtonsGroup>
            </Styled.EditButtonContainer>
            <Styled.FirstBlock>
              <InformationCollum />
              <form>
                <AddressCollum
                  control={controlUserForm}
                  isEditing={isEditing}
                  cancel={cancel}
                  handleSubmit={handleUserData(editUser)}
                  errors={errors}
                />
              </form>
            </Styled.FirstBlock>
            <LegalRepresentative />
            <Styled.Line />
            <Styled.SecondBlock>
              <Accounts />
            </Styled.SecondBlock>
            <Styled.Line />
            <Styled.ThirdBlock>
              <TaxCollum />
            </Styled.ThirdBlock>
          </>
        )}
      </Modal>

      <ModalPassword
        openModal={isModalPasswordOpen}
        closeModal={closeModalPassword}
        nextFunction={callFunction}
      />
      <ModalBlockUser
        openModal={isModalBlockUserOpen}
        closeModal={() => {
          setIsModalBlockUserOpen(false);
          closeModalInfo();
          dispatch(approvedUsersFetchAction(filter));
        }}
        blockUser
      />
    </div>
  );
}

UsuariosAprovados.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default memo(UsuariosAprovados);
